// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon{-ms-flex-negative:0;flex-shrink:0;-webkit-box-sizing:content-box;box-sizing:content-box}.icon:not([fill]){fill:var(--icon-color,currentColor)}", ""]);
// Exports
module.exports = exports;
